export default __webpack_public_path__ + "641694a91d9f6b724015ac4c6d307466.png";